import { postLogin, postVerifyOtp } from '../services/authservices';
import { Login, Otp } from '../constant/serviceType';
import { NavigateFunction } from 'react-router-dom';
import { showToast } from '../../Storeredux/constants/toastAction';
// import { useToast } from '../../Store/NotificationContext';

export const loginUser = async (payload: Login, navigate: NavigateFunction) => {
  let userResponse = null;
  // const { showToast } = useToast();
  try {
    const response = await postLogin(payload);
    userResponse = response?.data?.data;
    console.log(userResponse);
    if (userResponse) {
      // console.log(navigate);
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const access_token = 'verified';
      navigate('/app/properties');
      return { success: true, data: access_token, user: userResponse };
    }
  } catch (e: any) {
    console.log('gdgdgd', e);
    showToast('Error', e.response.data.message, 'error');
    return { success: false, error: e.response.data.message };
  }

  return userResponse;
};


export const verifyOtp = async (payload: Otp, navigate: NavigateFunction) => {
  let userResponse = null;
  try {
    const response = await postVerifyOtp(payload);
    userResponse = response?.data?.data;
    if (userResponse) {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const access_token = 'verified';
      navigate('/app/properties');
      return { success: true, data: access_token, user: userResponse };
    }
  } catch (e: any) {
    // console.log(e.response.data.message);
    return { success: false, error: e.response.data.error };
  }

  return userResponse;
};

